import zh from "./zh/index";

export default {
  ...zh,
  language: {
    switch: "切换语言成功",
  },
  role: {
    permission: "权限",
  },
  user: {
    uname: "用户名",
    role: "角色",
    sex: "性别",
    account: {
      info: "个人中心",
      logout: "登出",
    },
  },
  action: {
    success: "操作成功",
    error: "操作失败",
    delete: "此操作将永久删除该条记录, 是否继续?",
    delSuccess: "删除成功",
    editSuccess: "编辑成功",
    logout: "您确定退出系统吗？",
    tips: "提示",
    confirm: "确定要提交表单吗？",
    cancel: "取消",
    confirmBtn: "确定",
    examine: "审核",
    accountLoginWarning: "账号异常登录，若不是您本人操作，请尽快进行安全检查。",
    submit: "提交",
  },
};
